var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShown,
          expression: "modalShown"
        },
        {
          name: "drag",
          rawName: "v-drag",
          value: { handle: "#modal-moving" },
          expression: "{handle:'#modal-moving'}"
        }
      ],
      staticClass: "modal",
      staticStyle: { position: "fixed" },
      attrs: { id: "register-config-modal" }
    },
    [
      _c("div", { staticClass: "modal-main" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.corpInfo && Object.keys(_vm.corpInfo).length > 0
          ? _c("div", { staticClass: "data-area" }, [
              _c("div", { staticClass: "error_message" }, [
                _vm._v(_vm._s(_vm.errorMessage.text))
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c("span", { staticClass: "label" }, [_vm._v("企業名")]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.corpInfo.corpName))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.corpInfo.corpNameShort))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "label" }, [_vm._v("郵便番号")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.postcd,
                        expression: "postcd"
                      }
                    ],
                    attrs: {
                      type: "text",
                      maxlength: "7",
                      placeholder: "郵便番号"
                    },
                    domProps: { value: _vm.postcd },
                    on: {
                      keypress: _vm.validateNumber,
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.postcd = $event.target.value
                        },
                        function($event) {
                          _vm.postcd = _vm.inputRestNumber($event)
                        }
                      ]
                    }
                  })
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "label" }, [_vm._v("都道府県")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.state,
                        expression: "state"
                      }
                    ],
                    attrs: { type: "text", placeholder: "住所" },
                    domProps: { value: _vm.state },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.state = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "label" }, [_vm._v("市区町村")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.city,
                        expression: "city"
                      }
                    ],
                    attrs: { type: "text", placeholder: "住所" },
                    domProps: { value: _vm.city },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.city = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("その他住所/番地")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.street,
                        expression: "street"
                      }
                    ],
                    attrs: { type: "text", placeholder: "住所" },
                    domProps: { value: _vm.street },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.street = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "label" }, [_vm._v("電話番号")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.tel,
                        expression: "tel"
                      }
                    ],
                    attrs: {
                      type: "text",
                      maxlength: "16",
                      placeholder: "電話番号"
                    },
                    domProps: { value: _vm.tel },
                    on: {
                      keypress: _vm.validateNumber,
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.tel = $event.target.value
                        },
                        function($event) {
                          _vm.tel = _vm.inputRestNumber($event)
                        }
                      ]
                    }
                  })
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "label" }, [_vm._v("FAX")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.fax,
                        expression: "fax"
                      }
                    ],
                    attrs: {
                      type: "text",
                      maxlength: "16",
                      placeholder: "FAX"
                    },
                    domProps: { value: _vm.fax },
                    on: {
                      keypress: _vm.validateNumber,
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.fax = $event.target.value
                        },
                        function($event) {
                          _vm.fax = _vm.inputRestNumber($event)
                        }
                      ]
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm._m(2)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["postcd"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["state"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["city"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["street"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["tel"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["fax"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "button-area" }, [
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.onUpdate }
            },
            [_vm._v("設定")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.onCancel }
            },
            [_vm._v("キャンセル")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "title-area", attrs: { id: "modal-moving" } },
      [_c("h2", [_vm._v("登録情報設定")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "label" }, [
      _vm._v("略称企業名"),
      _c("span", { staticClass: "count_limit" }, [_vm._v("(半角16文字以内)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v("※企業名および略称企業名の変更をご希望の方は"),
      _c("br"),
      _vm._v("お問合せよりご連絡ください")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-597278b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-597278b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/common/CorpInfoModal.vue
// module id = null
// module chunks = 